import { c as _c } from "react/compiler-runtime";
import { useToggle } from '@react-hookz/web/useToggle/index.js';
import { IconSystemButton } from '#components/base/IconButton/IconSystemButton';
import type { ModuleType } from '#types/global';
import { ArticleType } from '../ArticleType';
import { PublicationDate } from '../PublicationDate';
import styles from './ArticlePublicationDate.module.scss';
import { ArticleUpdatedAtDate } from './ArticleUpdatedAtDate';
type Props = {
  publicationDate: string | null | undefined;
  updatedAt?: string | null;
  className?: string;
  moduleType: ModuleType | undefined | null;
};
export function ArticlePublicationDate(t0) {
  const $ = _c(24);
  const {
    className: t1,
    publicationDate,
    updatedAt,
    moduleType
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const [isExpanded, toggleExpanded] = useToggle(false);
  let t2;
  if ($[0] !== publicationDate) {
    t2 = <PublicationDate publicationDate={publicationDate} firstPublicationDate={publicationDate} formatAbsolute={true} />;
    $[0] = publicationDate;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const firstPublicationDate = t2;
  let t3;
  if ($[2] !== moduleType) {
    t3 = <ArticleType className={styles.articleType} moduleType={moduleType} iconSize="xs" />;
    $[2] = moduleType;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const articleType = t3;
  if (!updatedAt) {
    const t4 = `${className} ${styles.notUpdated}`;
    let t5;
    if ($[4] !== articleType || $[5] !== firstPublicationDate || $[6] !== t4) {
      t5 = <div className={t4}>{firstPublicationDate}{articleType}</div>;
      $[4] = articleType;
      $[5] = firstPublicationDate;
      $[6] = t4;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  } else {
    const t4 = `${className} ${isExpanded ? styles.expanded : ""}`;
    let t5;
    if ($[8] !== updatedAt) {
      t5 = <span>Aktualisiert am <ArticleUpdatedAtDate updatedAt={updatedAt} /></span>;
      $[8] = updatedAt;
      $[9] = t5;
    } else {
      t5 = $[9];
    }
    const t6 = isExpanded ? "Publikationsdatum ausblenden" : "Publikationsdatum anzeigen";
    let t7;
    if ($[10] !== isExpanded || $[11] !== t6) {
      t7 = <IconSystemButton type="quartiary" size="xs" icon="chevron-down" variant="filled" className={styles.button} aria-label={t6} aria-expanded={isExpanded} />;
      $[10] = isExpanded;
      $[11] = t6;
      $[12] = t7;
    } else {
      t7 = $[12];
    }
    let t8;
    if ($[13] !== articleType || $[14] !== t5 || $[15] !== t7 || $[16] !== toggleExpanded) {
      t8 = <div className={styles.top} onClick={toggleExpanded}>{t5}{t7}{articleType}</div>;
      $[13] = articleType;
      $[14] = t5;
      $[15] = t7;
      $[16] = toggleExpanded;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    let t9;
    if ($[18] !== firstPublicationDate) {
      t9 = <div className={styles.publicationDate}>Erschien zuerst am {firstPublicationDate}</div>;
      $[18] = firstPublicationDate;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    let t10;
    if ($[20] !== t4 || $[21] !== t8 || $[22] !== t9) {
      t10 = <div className={t4}>{t8}{t9}</div>;
      $[20] = t4;
      $[21] = t8;
      $[22] = t9;
      $[23] = t10;
    } else {
      t10 = $[23];
    }
    return t10;
  }
}